<template>
  <jc-dialog ref="createDialog"
             :buttons="buttons"
             :show.sync="show"
             column-class="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1"
             title="Danh sách quyền"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <div style="overflow: hidden">
      <b-row>
        <b-col>
          <c-table ref="table"
                   :data-filter="searchForm"
                   :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã quyền', sortField:'code', sortable: true},
                   {text: 'Thao tác', sortField:'granted', sortable: true, width: '150px'},
               ]"
                   uri="/cms/api/v1.0/admin/permission/get-all"
          >
            <template #button>
              <c-form style="text-align: justify" @submit="$refs.table.reload()">
                <b-input-group style="margin-bottom: 0px">

                  <template v-if="searchType === 2">
                    <select2 v-model="searchForm.resourceId"
                             :data-ajax--delay="250"
                             :data-ajax--url="baseUrl + 'cms/api/v1.0/admin/resources/select2'"
                             data-placeholder="Mã tài nguyên"
                    ></select2>
                    <select2 v-model="searchForm.actionId"
                             :data-ajax--delay="250"
                             :data-ajax--url="baseUrl + 'cms/api/v1.0/admin/actions/select2'"
                             data-placeholder="Mã hành động"
                    ></select2>
                  </template>


                  <b-form-input v-if="searchType === 1" v-model="searchForm.code" placeholder="Tìm kiếm theo mã quyền..."/>

                  <b-input-group-append>
                    <b-dropdown :split-variant="variant"
                                :variant="variant" right
                                split
                                @click="search()"
                    >
                      <template #button-content>
                        <i class="fas fa-search"></i>
                      </template>

                      <b-dropdown-item @click="searchType = 1"><i class="fas fa-search"></i> Tìm kiếm theo mã quyền</b-dropdown-item>
                      <b-dropdown-item @click="searchType = 2"><i class="fas fa-plus-circle"></i> Tìm kiếm theo mã tài nguyên và hành động
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
              </c-form>
            </template>
            <template #default="{item, index}">
              <td class="text-right">{{ index }}</td>
              <td>{{ item.code }}</td>
              <td class="text-center">

                <b-button
                    v-if="item.granted"
                    class="btn btn-icon"
                    title="Xóa"
                    type="button"
                    variant="danger"
                    @click="deleteItem(item)"
                    v-has-permission="'role_permission_delete'"
                >
                  <i class="far fa-minus-circle"></i>
                </b-button>

                <b-button
                    v-else
                    class="btn btn-icon"
                    title="Thêm quyền"
                    type="button"
                    variant="success"
                    @click="addItem(item)"
                    v-has-permission="'role_permission_create'"
                >
                  <i class="far fa-plus-circle"></i>
                </b-button>


              </td>
            </template>
          </c-table>
        </b-col>
      </b-row>

    </div>
  </jc-dialog>
</template>

<script>

import Select2 from "@/components/Forms/Select2";
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "ListActionDialog",
  mixins: [
    dialogMixins,
  ],
  components: {Select2},
  data: function () {
    return {
      buttons: {
        close: {
          text: 'Đóng',
          btnClass: 'btn-secondary btn-sm btn-simple',
        }
      },
      searchForm: {
        code: null,
        resourceId: null,
        actionId: null,
        roleId: null
      },
      createForm: {
        actionId: null
      },
      roleId: null,
      searchType: 1
    }
  },
  computed: {
    variant() {
      return this.isCreated ? 'success' : 'secondary';
    },
    baseUrl() {
      return process.env.VUE_APP_API_URL;
    },
  },
  methods: {
    open(item) {
      this.roleId = item.id;
      this.show = true;
      this.searchForm = {
        code: null,
        resourceId: null,
        actionId: null,
        roleId: this.roleId
      };
      this.createForm = {
        actionId: null
      };
      this.$refs.createDialog.getContentDOM();
    },
    searchOrCreate() {
      if (this.isCreated) {
        this.create();
      } else {
        this.search();
      }
    },
    search() {
      this.$refs.table.reload();
    },
    create() {
      this.$showLoader();

      this.$http.post('/cms/api/v1.0/admin/permission', {
        resourceId: this.resourceId,
        actionId: this.createForm.actionId
      }).then(res => {
        this.$stopLoader();
        this.$success();
        this.search();
        this.createForm.actionId = null;
      }, reason => {
        this.$stopLoader();
        this.errorNotify(reason);
      })
    },
    deleteItem(item) {
      this.$showLoader();

      this.$http
          .delete(`/cms/api/v1.0/admin/roles/${this.roleId}/permission/${item.id}`)
          .then(res => {
            this.$stopLoader();
            this.$success();
            this.search();
          }, reason => {
            this.$stopLoader();
            this.errorNotify(reason);
          });
    },
    addItem(item) {
      this.$showLoader();

      this.$http
          .post(
              '/cms/api/v1.0/admin/roles/permission',
              {
                roleId: this.roleId,
                permissionId: item.id
              }
          )
          .then(res => {
            this.$stopLoader();
            this.$success();
            this.search();
          }, reason => {
            this.$stopLoader();
            this.errorNotify(reason);
          });
    }
  }
}
</script>

<style>
</style>